import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import features from "../featuresData";

const Features = () => {
  return (
    <Wrapper>
      <section className='features clearfix' id='features'>
        {features.map((item) => {
          const { id, feature, icon, description } = item;
          return (
            <article className='feature' key={id}>
              <span className='feature-icon'>
                <FontAwesomeIcon icon={icon} />
              </span>
              <h4 className='feature-title'>{feature}</h4>
              <p className='feature-text'>{description}</p>
            </article>
          );
        })}
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .features {
    background: var(--clr-grey-10);
  }

  .feature {
    padding: 2.5rem 0;
    text-align: center;
    transition: var(--transition);
  }

  .feature-icon {
    font-size: 2.5rem;
    margin-bottom: 1.25rem;
    transition: var(--transition);
    display: inline-block;
    color: var(--clr-primary);
  }

  .feature-text {
    color: var(--clr-grey-5);
    max-width: 17rem;
    margin: 0 auto;
  }

  .feature:hover {
    background: var(--clr-white);
    box-shadow: 0 3px var(--clr-primary);
  }

  .feature:hover .feature-icon {
    transform: translateY(-5px);
  }

  @media screen and (min-width: 576px) {
    .feature {
      float: left;
      // 50% width will render a two column layout
      width: 50%;
    }
  }

  @media screen and (min-width: 1200px) {
    .feature {
      // 50% width will render a one row with each element taking 25%
      width: 25%;
    }
  }
`;

export default Features;
